export default "__VITE_ASSET__DHE41DNz__"